import React, { Component } from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'
import generateValidator from './Validations/generateValidator';
import { FormattedHTMLMessage } from 'react-intl';
import CustomAlert from '../components/CustomAlert.js';
import withAuthControl from '../auth/Auth.js';
import  {checkSummary}  from '../utils/utils.js'
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';
import CustomDatePicker from './CustomDatePicker.js';
import RenderField from './RenderField';
import axios from 'axios';
import CheckSummary from './CheckSummary';
import Header from './Header.js';

class CheckDetailForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            validateAmount: false,
            validateDate: false,
            validateType: false,
            interest_rate: null,
            summary: null
        }

        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleCalculation = this.handleCalculation.bind(this);
        this.handleLastStep = this.handleLastStep.bind(this);
    }

    handleNextStep(event) {
        event.preventDefault();
        const { check_amount, check_date, check_type } = this.props
        !check_amount ? this.setState({ validateAmount: true }) : this.setState({ validateAmount: false });
        !check_date ? this.setState({ validateDate: true }) : this.setState({ validateDate: false });
        (!check_type || check_type  === 'false') ? this.setState({ validateType: true }) : this.setState({ validateType: false });

        if (check_amount && check_date && check_type && check_type !== 'false') {
            this.setState({ isLoading: true });
            this.handleCalculation();
        }
    }

    handleCalculation() {
        const { check_amount, check_date, check_type } = this.props;

        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
            {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };
        axios.get(`${ROOT_URL}/leads/tna`, config).then((response) => {
            this.setState({
                rate_interest: response.data.tna / 100,
                isLoading: false
            })

            const results = new checkSummary(check_amount, check_date, this.state.rate_interest)
            this.setState({
                summary: results
            })
        })

    }

    handleLastStep() {
        this.setState({
            isLoading: true,
            summary: null
        })
        setTimeout(()=> this.setState({isLoading: false}),1)
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const check_options = [{ id: 0, name: 'Físico' }, { id: 1, name: 'Echeq' }]

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        {!this.state.summary && <FormattedHTMLMessage id="app.step_check_detail" description="Fields Generic" />}
                    </Header>
                    <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                        <form onSubmit={handleSubmit(this.props.saveCheckDetail)} className="pvc-form">
                            {(this.props.isLoading || this.state.isLoading) && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' />}
                            {error && <CustomAlert bsStyle="danger" message={error} />}
                            {!this.state.summary && (
                                <div>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className={this.state.validateAmount ? "form-group has-error" : "form-group"}>
                                                <Field className="form-control" name="check_amount" autoComplete="off" component={RenderField} type="number" label="Monto del cheque" placeholder='Monto del cheque' onChange={this.handleChange} />
                                                {((this.state.validateAmount && <div className="help-block"><span>{'Este Campo es Obligatorio'}</span></div>))}
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className={this.state.validateDate ? "form-group has-error" : "form-group"}>
                                                <Field name="check_date" label="Fecha" placeholder='Fecha' component={CustomDatePicker} calendarRange={true} onChange={this.handleChange} />
                                                {((this.state.validateDate && <div className="help-block"><span>{'Este Campo es Obligatorio'}</span></div>))}
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className={this.state.validateType ? "form-group has-error" : "form-group"}>
                                                <AttributeOptions name="check_type" defaultValue="Tipo de cheque" label="Tipo de cheque" attributeName='check_type' attributeOptions={check_options} onChange={this.handleChange} />
                                                {((this.state.validateType && <div className="help-block"><span>{'Este Campo es Obligatorio'}</span></div>))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                            <button onClick={this.handleNextStep} className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Simular</button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.state.summary && (
                                <div>
                                    <div className="row">
                                        <CheckSummary summary={this.state.summary}/>
                                            <div className="row">
                                                <button type="submit" onClick={this.handleLastStep} className="btn btn-warning btn-lg pd-button-custom pd-form back">Volver</button>
                                                <button type="submit" className="btn btn-warning btn-lg pd-button-custom pd-form continue">Seguir</button>
                                            </div>
                                        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                        <SaveStepButton/>
                    </div>
                </div>
            </Section>
        );
    }
}

CheckDetailForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const selector = formValueSelector('CheckDetailForm')

CheckDetailForm = connect(
    state => {
        const check_amount = selector(state, 'check_amount')
        const check_date = selector(state, 'check_date')
        const check_type = selector(state, 'check_type')
        return {
            check_amount,
            check_date,
            check_type
        }
    }
)(CheckDetailForm)

CheckDetailForm = TopScrolleable(CheckDetailForm);
let validate = generateValidator([{name: 'check_amount', required: true}, {name: 'check_date', required: true}, {name: 'check_type', required: true}]);

CheckDetailForm = reduxForm({
    form: 'CheckDetailForm', // a unique name for this form
    validate
})(CheckDetailForm);

CheckDetailForm = withAuthControl(CheckDetailForm);

export default CheckDetailForm;



/** WEBPACK FOOTER **
 ** ./src/components/CheckDetailForm.js
 **/